// extracted by mini-css-extract-plugin
export default {"grid":"tag-categories_grid__Desj+"};